/**
 * Noir Gift Form
 * On submit, two things happen:
 *   1. The catalogue PDF is force-downloaded (a real save-to-disk
 *      download, not just opened in a tab).
 *   2. Right after that, the form submits for real to Shopify's
 *      native contact form, which emails the lead to your
 *      notification inbox (Settings > Notifications).
 *
 * The final submission is a genuine browser form submission
 * (form.submit()), not an AJAX/fetch call — that's deliberate.
 * Shopify's spam protection tends to block JavaScript-driven POSTs
 * to /contact; a real submission goes through the normal, expected
 * flow instead.
 */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function () {
    document.querySelectorAll('.noirgiftform').forEach(initNoirGiftForm);
  });

  function initNoirGiftForm(root) {
    var form = root.querySelector('.noirgiftform__form');
    if (!form) return;

    var nameInput = form.querySelector('input[name="contact[name]"]');
    var emailInput = form.querySelector('input[name="contact[email]"]');
    var phoneInput = form.querySelector('input[name="contact[phone]"]');
    var honeypot = form.querySelector('input[name="company_website"]');
    var catalogUrl = root.getAttribute('data-catalog-url');

    [nameInput, emailInput, phoneInput].forEach(function (input) {
      if (!input) return;
      input.addEventListener('input', function () {
        input.removeAttribute('aria-invalid');
      });
    });

    form.addEventListener('submit', function (e) {
      // Silently drop likely-bot submissions.
      if (honeypot && honeypot.value) {
        e.preventDefault();
        return;
      }

      var name = ((nameInput && nameInput.value) || '').trim();
      var email = ((emailInput && emailInput.value) || '').trim();
      var phone = ((phoneInput && phoneInput.value) || '').trim();

      var nameValid = validateField(nameInput, name.length > 1);
      var emailValid = validateField(emailInput, /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email));
      var phoneValid = validateField(phoneInput, phone.replace(/[^0-9]/g, '').length >= 7);

      if (!nameValid || !emailValid || !phoneValid) {
        // Block the real submission until the fields are valid.
        e.preventDefault();
        return;
      }

      // Fields are valid: hold the real submission just long enough to
      // force the PDF to actually download, then submit for real.
      e.preventDefault();
      triggerDownload(catalogUrl, function () {
        form.submit();
      });
    });

    // ------------------------------------------------------------------
    // Forces a real "save to disk" download regardless of browser or
    // file origin. window.open()/plain <a download> aren't reliable for
    // cross-origin files like Shopify's CDN — fetching as a blob and
    // downloading *that* is the one method that works everywhere.
    // `done` is called once the download has been kicked off (or has
    // failed), so the real form submission can proceed either way.
    // ------------------------------------------------------------------
    function triggerDownload(url, done) {
      if (!url) {
        done();
        return;
      }

      fetch(url, { credentials: 'omit' })
        .then(function (res) {
          if (!res.ok) throw new Error('Catalogue fetch failed');
          return res.blob();
        })
        .then(function (blob) {
          var blobUrl = URL.createObjectURL(blob);
          var link = document.createElement('a');
          link.href = blobUrl;
          link.download = (url.split('/').pop() || 'catalogue.pdf').split('?')[0];
          document.body.appendChild(link);
          link.click();
          link.remove();
          setTimeout(function () { URL.revokeObjectURL(blobUrl); }, 4000);
          done();
        })
        .catch(function () {
          // Fallback if the fetch fails (e.g. CORS): at least open the
          // file in a new tab so the visitor can still get it.
          window.open(url, '_blank', 'noopener');
          done();
        });
    }

    function validateField(input, isValid) {
      if (!input) return true;
      if (isValid) {
        input.removeAttribute('aria-invalid');
      } else {
        input.setAttribute('aria-invalid', 'true');
      }
      return isValid;
    }
  }
})();